export default (params) => `
  <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:web="http://webservice/">
    <soapenv:Header/>
    <soapenv:Body>
      <web:getServiceProviders>
        <serviceType>${params.serviceType}</serviceType>
        <sourceCountryId>${params.sourceCountryId}</sourceCountryId>
        <destinationCountryId>${params.destinationCountryId}</destinationCountryId>
        <userId>${params.userId}</userId>
        <userKey>${params.userKey}</userKey>
      </web:getServiceProviders>
    </soapenv:Body>
  </soapenv:Envelope>
`
